import * as React from 'react';

import type { LocationTo } from './createHistory';
import { useHistory } from './useHistory';

/**
 * Redirect the user to another location.
 */
export function HistoryRedirect(props: {
    to: LocationTo;
    push?: boolean;
}): React.ReactElement | null {
    const { to, push = false } = props;

    const history = useHistory();

    if (history.staticContext) {
        if (push) {
            history.push(to);
        } else {
            history.replace(to);
        }
    }

    React.useEffect(() => {
        if (push) {
            history.push(to);
        } else {
            history.replace(to);
        }
    }, [history, push]);

    return null;
}
